// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Alert = require("../common/Components/Alert.bs.js");
let React = require("react");
let Scalars = require("../../scalars/Scalars.bs.js");
let ButtonsV5 = require("../common/Components/ButtonsV5.bs.js");
let Formality = require("@tan/formality/src/Formality.bs.js");
let Stdlib_Int = require("@rescript/runtime/lib/js/Stdlib_Int.js");
let Breadcrumbs = require("../common/Components/Breadcrumbs.bs.js");
let Form__Label = require("../common/Components/Form__Label.bs.js");
let FormalityUI = require("../common/Components/FormalityUI.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Form__TextInput = require("../common/Components/Form__TextInput.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let Formality__ReactUpdate = require("@tan/formality/src/Formality__ReactUpdate.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let MarketingProfileSubpages = require("./MarketingProfileSubpages.bs.js");
let UnselectedUnionMemberError = require("../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
let TeamMarketingProfileBasicInfoSettingsQuery_graphql = require("../../__generated__/TeamMarketingProfileBasicInfoSettingsQuery_graphql.bs.js");
let TeamMarketingProfileBasicInfoSettingsMutation_graphql = require("../../__generated__/TeamMarketingProfileBasicInfoSettingsMutation_graphql.bs.js");
let TeamMarketingProfileBasicInfoSettings_form_agentMarketingProfile_graphql = require("../../__generated__/TeamMarketingProfileBasicInfoSettings_form_agentMarketingProfile_graphql.bs.js");

let validators_teamSize = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: param => {
    let teamSize = param.teamSize;
    if (teamSize === "") {
      return {
        TAG: "Ok",
        _0: undefined
      };
    }
    let n = Stdlib_Int.fromString(teamSize, undefined);
    if (n !== undefined) {
      return {
        TAG: "Ok",
        _0: n
      };
    } else {
      return {
        TAG: "Error",
        _0: "NotANumber"
      };
    }
  }
};

let validators_website = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: param => {
    let website = param.website;
    if (website === "") {
      return {
        TAG: "Ok",
        _0: undefined
      };
    }
    let e = Scalars.URL.fromString(website);
    if (e.TAG === "Ok") {
      return {
        TAG: "Ok",
        _0: Primitive_option.some(e._0)
      };
    } else {
      return {
        TAG: "Error",
        _0: "InvalidURL"
      };
    }
  }
};

let validators_brokerage = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: param => {
    let brokerage = param.brokerage;
    if (brokerage === "") {
      return {
        TAG: "Ok",
        _0: undefined
      };
    } else {
      return {
        TAG: "Ok",
        _0: brokerage
      };
    }
  }
};

let validators_teamName = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: param => {
    let teamName = param.teamName;
    if (teamName === "") {
      return {
        TAG: "Error",
        _0: "IsRequired"
      };
    } else {
      return {
        TAG: "Ok",
        _0: teamName
      };
    }
  }
};

let validators = {
  teamSize: validators_teamSize,
  website: validators_website,
  brokerage: validators_brokerage,
  teamName: validators_teamName
};

function initialFieldsStatuses(input) {
  return {
    teamSize: "Pristine",
    website: "Pristine",
    brokerage: "Pristine",
    teamName: "Pristine"
  };
}

function initialFieldStatuses_xxx(x) {
  return {
    teamSize: "Pristine",
    website: "Pristine",
    brokerage: "Pristine",
    teamName: "Pristine"
  };
}

function initialState(input) {
  return {
    input: input,
    fieldsStatuses: {
      teamSize: "Pristine",
      website: "Pristine",
      brokerage: "Pristine",
      teamName: "Pristine"
    },
    collectionsStatuses: undefined,
    formStatus: "Editing",
    submissionStatus: "NeverSubmitted"
  };
}

function validateForm(input, validators, fieldsStatuses) {
  let match = fieldsStatuses.teamSize;
  let tmp;
  tmp = typeof match !== "object" ? validators.teamSize.validate(input) : match._0;
  let match$1 = fieldsStatuses.website;
  let tmp$1;
  tmp$1 = typeof match$1 !== "object" ? validators.website.validate(input) : match$1._0;
  let match$2 = fieldsStatuses.brokerage;
  let tmp$2;
  tmp$2 = typeof match$2 !== "object" ? validators.brokerage.validate(input) : match$2._0;
  let match$3 = fieldsStatuses.teamName;
  let tmp$3;
  tmp$3 = typeof match$3 !== "object" ? validators.teamName.validate(input) : match$3._0;
  let teamSizeResult = tmp;
  let teamSizeResult$1;
  if (teamSizeResult.TAG === "Ok") {
    let websiteResult = tmp$1;
    if (websiteResult.TAG === "Ok") {
      let brokerageResult = tmp$2;
      if (brokerageResult.TAG === "Ok") {
        let teamNameResult = tmp$3;
        if (teamNameResult.TAG === "Ok") {
          return {
            TAG: "Valid",
            output: {
              teamName: teamNameResult._0,
              brokerage: brokerageResult._0,
              website: websiteResult._0,
              teamSize: teamSizeResult._0
            },
            fieldsStatuses: {
              teamSize: {
                TAG: "Dirty",
                _0: teamSizeResult,
                _1: "Shown"
              },
              website: {
                TAG: "Dirty",
                _0: websiteResult,
                _1: "Shown"
              },
              brokerage: {
                TAG: "Dirty",
                _0: brokerageResult,
                _1: "Shown"
              },
              teamName: {
                TAG: "Dirty",
                _0: teamNameResult,
                _1: "Shown"
              }
            },
            collectionsStatuses: undefined
          };
        }
        teamSizeResult$1 = teamSizeResult;
      } else {
        teamSizeResult$1 = teamSizeResult;
      }
    } else {
      teamSizeResult$1 = teamSizeResult;
    }
  } else {
    teamSizeResult$1 = teamSizeResult;
  }
  return {
    TAG: "Invalid",
    fieldsStatuses: {
      teamSize: {
        TAG: "Dirty",
        _0: teamSizeResult$1,
        _1: "Shown"
      },
      website: {
        TAG: "Dirty",
        _0: tmp$1,
        _1: "Shown"
      },
      brokerage: {
        TAG: "Dirty",
        _0: tmp$2,
        _1: "Shown"
      },
      teamName: {
        TAG: "Dirty",
        _0: tmp$3,
        _1: "Shown"
      }
    },
    collectionsStatuses: undefined
  };
}

function useForm(initialInput, onSubmit) {
  let memoizedInitialState = React.useMemo(() => initialState(initialInput), [initialInput]);
  let match = Formality__ReactUpdate.useReducer(memoizedInitialState, (state, action) => {
    if (typeof action !== "object") {
      switch (action) {
        case "BlurTeamSizeField" :
          let result = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.teamSize, validators_teamSize, status => {
            let init = state.fieldsStatuses;
            return {
              teamSize: status,
              website: init.website,
              brokerage: init.brokerage,
              teamName: init.teamName
            };
          });
          if (result !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurWebsiteField" :
          let result$1 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.website, validators_website, status => {
            let init = state.fieldsStatuses;
            return {
              teamSize: init.teamSize,
              website: status,
              brokerage: init.brokerage,
              teamName: init.teamName
            };
          });
          if (result$1 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$1,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurBrokerageField" :
          let result$2 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.brokerage, validators_brokerage, status => {
            let init = state.fieldsStatuses;
            return {
              teamSize: init.teamSize,
              website: init.website,
              brokerage: status,
              teamName: init.teamName
            };
          });
          if (result$2 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$2,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurTeamNameField" :
          let result$3 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.teamName, validators_teamName, status => {
            let init = state.fieldsStatuses;
            return {
              teamSize: init.teamSize,
              website: init.website,
              brokerage: init.brokerage,
              teamName: status
            };
          });
          if (result$3 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$3,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "Submit" :
          let match = state.formStatus;
          if (typeof match === "object" && match.TAG === "Submitting") {
            return "NoUpdate";
          }
          let match$1 = validateForm(state.input, validators, state.fieldsStatuses);
          if (match$1.TAG !== "Valid") {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: match$1.fieldsStatuses,
                collectionsStatuses: match$1.collectionsStatuses,
                formStatus: "Editing",
                submissionStatus: "AttemptedToSubmit"
              }
            };
          }
          let output = match$1.output;
          let error = state.formStatus;
          let tmp;
          tmp = typeof error !== "object" || error.TAG !== "SubmissionFailed" ? undefined : Primitive_option.some(error._0);
          return {
            TAG: "UpdateWithSideEffects",
            _0: {
              input: state.input,
              fieldsStatuses: match$1.fieldsStatuses,
              collectionsStatuses: match$1.collectionsStatuses,
              formStatus: {
                TAG: "Submitting",
                _0: tmp
              },
              submissionStatus: "AttemptedToSubmit"
            },
            _1: param => {
              let dispatch = param.dispatch;
              onSubmit(output, {
                notifyOnSuccess: input => dispatch({
                  TAG: "SetSubmittedStatus",
                  _0: input
                }),
                notifyOnFailure: error => dispatch({
                  TAG: "SetSubmissionFailedStatus",
                  _0: error
                }),
                reset: () => dispatch("Reset"),
                dismissSubmissionResult: () => dispatch("DismissSubmissionResult")
              });
            }
          };
          break;
        case "DismissSubmissionError" :
          let match$2 = state.formStatus;
          if (typeof match$2 !== "object" || match$2.TAG !== "SubmissionFailed") {
            return "NoUpdate";
          } else {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Editing",
                submissionStatus: state.submissionStatus
              }
            };
          }
        case "DismissSubmissionResult" :
          let match$3 = state.formStatus;
          if (typeof match$3 !== "object") {
            if (match$3 === "Editing") {
              return "NoUpdate";
            }
          } else if (match$3.TAG === "Submitting") {
            return "NoUpdate";
          }
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: state.fieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: "Editing",
              submissionStatus: state.submissionStatus
            }
          };
        case "Reset" :
          return {
            TAG: "Update",
            _0: initialState(initialInput)
          };
      }
    } else {
      switch (action.TAG) {
        case "UpdateTeamSizeField" :
          let nextInput = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput, state.fieldsStatuses.teamSize, state.submissionStatus, validators_teamSize, status => {
                let init = state.fieldsStatuses;
                return {
                  teamSize: status,
                  website: init.website,
                  brokerage: init.brokerage,
                  teamName: init.teamName
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateWebsiteField" :
          let nextInput$1 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$1,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$1, state.fieldsStatuses.website, state.submissionStatus, validators_website, status => {
                let init = state.fieldsStatuses;
                return {
                  teamSize: init.teamSize,
                  website: status,
                  brokerage: init.brokerage,
                  teamName: init.teamName
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateBrokerageField" :
          let nextInput$2 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$2,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$2, state.fieldsStatuses.brokerage, state.submissionStatus, validators_brokerage, status => {
                let init = state.fieldsStatuses;
                return {
                  teamSize: init.teamSize,
                  website: init.website,
                  brokerage: status,
                  teamName: init.teamName
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateTeamNameField" :
          let nextInput$3 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$3,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$3, state.fieldsStatuses.teamName, state.submissionStatus, validators_teamName, status => {
                let init = state.fieldsStatuses;
                return {
                  teamSize: init.teamSize,
                  website: init.website,
                  brokerage: init.brokerage,
                  teamName: status
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "SetSubmittedStatus" :
          let input = action._0;
          if (input !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: input,
                fieldsStatuses: {
                  teamSize: "Pristine",
                  website: "Pristine",
                  brokerage: "Pristine",
                  teamName: "Pristine"
                },
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Submitted",
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: {
                  teamSize: "Pristine",
                  website: "Pristine",
                  brokerage: "Pristine",
                  teamName: "Pristine"
                },
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Submitted",
                submissionStatus: state.submissionStatus
              }
            };
          }
        case "SetSubmissionFailedStatus" :
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: state.fieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: {
                TAG: "SubmissionFailed",
                _0: action._0
              },
              submissionStatus: state.submissionStatus
            }
          };
        case "MapSubmissionError" :
          let map = action._0;
          let error$1 = state.formStatus;
          if (typeof error$1 !== "object") {
            return "NoUpdate";
          }
          if (error$1.TAG !== "Submitting") {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: {
                  TAG: "SubmissionFailed",
                  _0: map(error$1._0)
                },
                submissionStatus: state.submissionStatus
              }
            };
          }
          let error$2 = error$1._0;
          if (error$2 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: {
                  TAG: "Submitting",
                  _0: Primitive_option.some(map(Primitive_option.valFromOption(error$2)))
                },
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
      }
    }
  });
  let dispatch = match[1];
  let state = match[0];
  let match$1 = state.formStatus;
  let tmp;
  tmp = typeof match$1 !== "object" ? false : match$1.TAG === "Submitting";
  return {
    updateTeamSize: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateTeamSizeField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateWebsite: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateWebsiteField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateBrokerage: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateBrokerageField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateTeamName: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateTeamNameField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    blurTeamSize: () => dispatch("BlurTeamSizeField"),
    blurWebsite: () => dispatch("BlurWebsiteField"),
    blurBrokerage: () => dispatch("BlurBrokerageField"),
    blurTeamName: () => dispatch("BlurTeamNameField"),
    teamSizeResult: Formality.exposeFieldResult(state.fieldsStatuses.teamSize),
    websiteResult: Formality.exposeFieldResult(state.fieldsStatuses.website),
    brokerageResult: Formality.exposeFieldResult(state.fieldsStatuses.brokerage),
    teamNameResult: Formality.exposeFieldResult(state.fieldsStatuses.teamName),
    input: state.input,
    status: state.formStatus,
    dirty: () => {
      let match = state.fieldsStatuses;
      let tmp = match.teamSize;
      if (typeof tmp === "object") {
        return true;
      }
      let tmp$1 = match.website;
      if (typeof tmp$1 === "object") {
        return true;
      }
      let tmp$2 = match.brokerage;
      if (typeof tmp$2 === "object") {
        return true;
      }
      let tmp$3 = match.teamName;
      return typeof tmp$3 === "object";
    },
    valid: () => {
      let match = validateForm(state.input, validators, state.fieldsStatuses);
      return match.TAG === "Valid";
    },
    submitting: tmp,
    submit: () => dispatch("Submit"),
    dismissSubmissionError: () => dispatch("DismissSubmissionError"),
    dismissSubmissionResult: () => dispatch("DismissSubmissionResult"),
    mapSubmissionError: map => dispatch({
      TAG: "MapSubmissionError",
      _0: map
    }),
    reset: () => dispatch("Reset")
  };
}

let Config = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialFieldStatuses_xxx: initialFieldStatuses_xxx,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

let convertFragment = TeamMarketingProfileBasicInfoSettings_form_agentMarketingProfile_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, TeamMarketingProfileBasicInfoSettings_form_agentMarketingProfile_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(TeamMarketingProfileBasicInfoSettings_form_agentMarketingProfile_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, TeamMarketingProfileBasicInfoSettings_form_agentMarketingProfile_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(TeamMarketingProfileBasicInfoSettings_form_agentMarketingProfile_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let convertVariables = TeamMarketingProfileBasicInfoSettingsMutation_graphql.Internal.convertVariables;

let convertResponse = TeamMarketingProfileBasicInfoSettingsMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = TeamMarketingProfileBasicInfoSettingsMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, TeamMarketingProfileBasicInfoSettingsMutation_graphql.node, convertResponse, convertWrapRawResponse);

let use$1 = RescriptRelay_Mutation.useMutation(convertVariables, TeamMarketingProfileBasicInfoSettingsMutation_graphql.node, convertResponse, convertWrapRawResponse);

let Mutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use$1
};

function initialInputFromFragment(fragment) {
  return {
    teamName: fragment.teamName,
    brokerage: Stdlib_Option.getOr(fragment.brokerage, ""),
    website: Stdlib_Option.getOr(Stdlib_Option.map(fragment.website, Scalars.URL.toString), ""),
    teamSize: Stdlib_Option.getOr(Stdlib_Option.map(fragment.teamSize, v => v.toString()), "")
  };
}

function messageToString(v) {
  if (v === "InvalidURL") {
    return "must be a valid URL";
  } else if (v === "IsRequired") {
    return "is required";
  } else {
    return "must be a number";
  }
}

function TeamMarketingProfileBasicInfoSettings$Form$FieldValidationMessage(props) {
  return JsxRuntime.jsx(FormalityUI.FieldValidationMessage.make, {
    messageToString: messageToString,
    result: props.result
  });
}

let FieldValidationMessage = {
  make: TeamMarketingProfileBasicInfoSettings$Form$FieldValidationMessage
};

function TeamMarketingProfileBasicInfoSettings$Form$InputField(props) {
  let status = props.status;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(Form__Label.make, {
          labelText: props.labelText
        }),
        className: "pt-2"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(Form__TextInput.make, {
            type: props._type,
            onChange: props.onChange,
            onBlur: props.onBlur,
            status: FormalityUI.UIKitStatus.ofOptFieldResult(status),
            value: props.value
          }),
          Stdlib_Option.getOr(Stdlib_Option.map(props.helpText, text => JsxRuntime.jsx("div", {
            children: text,
            className: "text-base text-gray-500"
          })), null),
          JsxRuntime.jsx(TeamMarketingProfileBasicInfoSettings$Form$FieldValidationMessage, {
            result: status
          })
        ],
        className: "mt-2 sm:col-span-2 sm:mt-0 sm:max-w-xs space-y-3"
      })
    ],
    className: "sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6"
  });
}

let InputField = {
  make: TeamMarketingProfileBasicInfoSettings$Form$InputField
};

function TeamMarketingProfileBasicInfoSettings$Form(props) {
  let marketingProfile = RescriptRelay_Fragment.useFragment(TeamMarketingProfileBasicInfoSettings_form_agentMarketingProfile_graphql.node, convertFragment, props.marketingProfile);
  let match = use$1();
  let mutate = match[0];
  let form = useForm(initialInputFromFragment(marketingProfile), (param, param$1) => {
    let notifyOnFailure = param$1.notifyOnFailure;
    let notifyOnSuccess = param$1.notifyOnSuccess;
    mutate({
      input: {
        brokerage: param.brokerage,
        teamName: param.teamName,
        teamSize: param.teamSize,
        website: param.website
      }
    }, undefined, undefined, undefined, (param, param$1) => {
      let result = param.updateTeamMarketingProfileBasicInfo;
      if (result === undefined) {
        return notifyOnFailure(undefined);
      }
      switch (result.__typename) {
        case "ProfileSettingsChangedError" :
          return notifyOnFailure(result.settingsChangedMessage);
        case "TeamMarketingProfileBasicInfoUpdated" :
          return notifyOnSuccess(undefined);
        case "__unselected" :
          return notifyOnFailure(undefined);
      }
    }, param => notifyOnFailure(undefined), undefined);
  });
  let message = form.status;
  let tmp;
  tmp = typeof message !== "object" ? (
      message === "Editing" ? null : JsxRuntime.jsx(Alert.Success.make, {
          title: "Your account was updated"
        })
    ) : (
      message.TAG === "Submitting" ? null : JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(Alert.$$Error.make, {
            title: Stdlib_Option.getOr(message._0, "There was an error updating your account. Please try again")
          }),
          className: "mt-4"
        })
    );
  return JsxRuntime.jsx("form", {
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(TeamMarketingProfileBasicInfoSettings$Form$InputField, {
              onChange: event => form.updateTeamName((input, value) => ({
                teamName: value,
                brokerage: input.brokerage,
                website: input.website,
                teamSize: input.teamSize
              }), event.target.value),
              onBlur: param => form.blurTeamName(),
              value: form.input.teamName,
              status: form.teamNameResult,
              labelText: "Team name"
            }),
            JsxRuntime.jsx(TeamMarketingProfileBasicInfoSettings$Form$InputField, {
              onChange: event => form.updateBrokerage((input, value) => ({
                teamName: input.teamName,
                brokerage: value,
                website: input.website,
                teamSize: input.teamSize
              }), event.target.value),
              onBlur: param => form.blurBrokerage(),
              value: form.input.brokerage,
              status: form.brokerageResult,
              labelText: "Brokerage"
            }),
            JsxRuntime.jsx(TeamMarketingProfileBasicInfoSettings$Form$InputField, {
              onChange: event => form.updateWebsite((input, value) => ({
                teamName: input.teamName,
                brokerage: input.brokerage,
                website: value,
                teamSize: input.teamSize
              }), event.target.value),
              onBlur: param => form.blurWebsite(),
              value: form.input.website,
              status: form.websiteResult,
              labelText: "Website"
            }),
            JsxRuntime.jsx(TeamMarketingProfileBasicInfoSettings$Form$InputField, {
              onChange: event => form.updateTeamSize((input, value) => ({
                teamName: input.teamName,
                brokerage: input.brokerage,
                website: input.website,
                teamSize: value
              }), event.target.value),
              onBlur: param => form.blurTeamSize(),
              value: form.input.teamSize,
              status: form.teamSizeResult,
              labelText: "Team size",
              helpText: "Optional. Sharing the number of agents on your team will help us serve teams better.",
              _type: "number"
            })
          ],
          className: "space-y-8 border-b border-zinc-200 pb-12 sm:space-y-0 sm:divide-y sm:divide-zinc-200 sm:pb-0"
        }),
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
              href: Scalars.URL.toString(marketingProfile.publicUrl),
              target: "_blank",
              children: "View Profile"
            }),
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
                  disabled: form.submitting,
                  children: "Save changes"
                }),
                JsxRuntime.jsx("div", {
                  children: tmp,
                  role: "status"
                })
              ],
              className: "flex flex-col items-end gap-3"
            })
          ],
          className: "flex justify-between items-baseline"
        })
      ],
      className: "space-y-6"
    }),
    onSubmit: event => {
      event.preventDefault();
      form.submit();
    }
  });
}

let Form = {
  Config: Config,
  Fragment: Fragment,
  Mutation: Mutation,
  initialInputFromFragment: initialInputFromFragment,
  messageToString: messageToString,
  FieldValidationMessage: FieldValidationMessage,
  InputField: InputField,
  make: TeamMarketingProfileBasicInfoSettings$Form
};

function TeamMarketingProfileBasicInfoSettings$Header(props) {
  let displayName = MarketingProfileSubpages.Page.Team.useDisplayName();
  let breadcrumbs = [
    {
      name: "Team Marketing Profile",
      href: "/account/team_marketing_profile"
    },
    {
      name: displayName("BasicInfo"),
      href: MarketingProfileSubpages.Page.Team.path("BasicInfo")
    }
  ];
  return JsxRuntime.jsxs("header", {
    children: [
      JsxRuntime.jsx(Breadcrumbs.make, {
        pages: breadcrumbs
      }),
      JsxRuntime.jsx("h2", {
        children: displayName("BasicInfo"),
        className: "text-zinc-800 text-3xl font-medium"
      })
    ],
    className: "space-y-3 border-b pb-2"
  });
}

let Header = {
  make: TeamMarketingProfileBasicInfoSettings$Header
};

let convertVariables$1 = TeamMarketingProfileBasicInfoSettingsQuery_graphql.Internal.convertVariables;

let convertResponse$1 = TeamMarketingProfileBasicInfoSettingsQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse$1 = TeamMarketingProfileBasicInfoSettingsQuery_graphql.Internal.convertWrapRawResponse;

let use$2 = RescriptRelay_Query.useQuery(convertVariables$1, TeamMarketingProfileBasicInfoSettingsQuery_graphql.node, convertResponse$1);

let useLoader = RescriptRelay_Query.useLoader(convertVariables$1, TeamMarketingProfileBasicInfoSettingsQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(TeamMarketingProfileBasicInfoSettingsQuery_graphql.node, convertResponse$1, prim => prim);

let fetch = RescriptRelay_Query.fetch_(TeamMarketingProfileBasicInfoSettingsQuery_graphql.node, convertResponse$1, convertVariables$1);

let fetchPromised = RescriptRelay_Query.fetchPromised(TeamMarketingProfileBasicInfoSettingsQuery_graphql.node, convertResponse$1, convertVariables$1);

let retain = RescriptRelay_Query.retain(TeamMarketingProfileBasicInfoSettingsQuery_graphql.node, convertVariables$1);

let Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$1,
  convertResponse: convertResponse$1,
  convertWrapRawResponse: convertWrapRawResponse$1,
  use: use$2,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function TeamMarketingProfileBasicInfoSettings(props) {
  let match = use$2(undefined, undefined, undefined, undefined);
  let marketingProfile = match.currentAccountV5.marketingProfile;
  if (marketingProfile.__typename === "TeamMarketingProfile") {
    return JsxRuntime.jsx("div", {
      children: JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(TeamMarketingProfileBasicInfoSettings$Header, {}),
          JsxRuntime.jsx(TeamMarketingProfileBasicInfoSettings$Form, {
            marketingProfile: marketingProfile.fragmentRefs
          })
        ],
        className: "space-y-8 sm:space-y-0"
      }),
      className: "bg-white p-6 shadow-sm rounded space-y-8"
    });
  } else {
    return UnselectedUnionMemberError.raise(`Unselected union member: ` + marketingProfile._0);
  }
}

let make = TeamMarketingProfileBasicInfoSettings;

exports.Form = Form;
exports.Header = Header;
exports.Query = Query;
exports.make = make;
/* commitMutation Not a pure module */
